import {useRoomPlannerContext} from 'components/customer/RoomPlanner/components/RoomPlannerContext';

export const useRoomPreview = () => {
    const {isRoomPreview = false} = useRoomPlannerContext();

    return isRoomPreview;
};
